<template>
  <div class="container-main-div">
    <!-- ++++++++++++ GRID ++++++++++++++++++++++++++++ -->

    <div class="gridWidth">
      <CmpGrid
        :GridData="gridTime"
        :EnablePaging="true"
        :EnableSearching="true"
        :EnableSorting="true"
      >
        <template v-slot:leftActionHeaderSlot
          ><div class="actionsHeader">View</div></template
        >

        <template v-slot:rightActionHeaderSlot
          ><div class="actionsHeader">Edit/Delete</div></template
        >
        <template v-slot:actionLeftSlot="slotArgs">
          <div>
            <div
              @click="editRow(slotArgs)"
              class="material-icons-outlined forIconInfo"
              data-tooltip="tooltip"
              title="View Details"
              data-bs-toggle="modal"
              data-bs-target="#infoModal"
            >
              info
            </div>
          </div>
        </template>

        <template v-slot:actionRightSlot="slotArgs">
          <div>
            <div
              @click="editRow(slotArgs)"
              class="material-icons forIconEdit"
              data-tooltip="tooltip"
              title="Edit Record"
              data-bs-toggle="modal"
              data-bs-target="#editModal"
            >
              edit
            </div>

            <div
              @click="deleteRow(slotArgs)"
              class="material-icons forIconDelete"
              data-bs-toggle="modal"
              data-bs-target="#deleteModalID"
              data-tooltip="tooltip"
              title="Delete Record"
            >
              delete
            </div>
          </div>
        </template>
      </CmpGrid>
    </div>
  </div>

  <!-- --------------------------------------------------------- -->
  <!-- ---------------- modal DELETE - Start ------------------- -->
  <!-- --------------------------------------------------------- -->

  <!-- Modal -->
  <div
    class="modal fade"
    id="deleteModalID"
    tabindex="-1"
    aria-labelledby="deleteModalLabelID"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabelID">
            Record Delete - are you sure?
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- FORM ------------------------------- -->
          <!-- ---------------------------------------------------------------- -->

          <div class="container-B-Form">
            <div
              class="justify-Content-Right font-Main-Elements modalElementMargin"
            >
              First Name:
            </div>
            <div class="justify-Content-Left font-record modalElementMargin">
              {{ firstName }}
            </div>
            <div
              class="justify-Content-Right font-Main-Elements modalElementMargin"
            >
              Last Name:
            </div>
            <div class="justify-Content-Left font-record modalElementMargin">
              {{ lastName }}
            </div>
            <div
              class="justify-Content-Right font-Main-Elements modalElementMargin"
            >
              Role:
            </div>
            <div class="justify-Content-Left font-record modalElementMargin">
              {{ role }}
            </div>
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- FORM END --------------------------- -->
          <!-- ---------------------------------------------------------------- -->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn closeButton" data-bs-dismiss="modal">
            Cancel
          </button>
          <button
            type="button"
            @click="handleSubmitDelete"
            class="btn yesButton"
            data-bs-dismiss="modal"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- --------------------------------------------------------- -->
  <!-- ---------------- modal DELETE - End --------------------- -->
  <!-- --------------------------------------------------------- -->

  <!-- --------------------------------------------------------- -->
  <!-- ---------------- modal EDIT - Start --------------------- -->
  <!-- --------------------------------------------------------- -->

  <div
    class="modal fade"
    id="editModal"
    tabindex="-1"
    aria-labelledby="editModalLabelID"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editModalLabelID">Edit Record</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dishandleTextboxInputmiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- FORM ------------------------------- -->
          <!-- ---------------------------------------------------------------- -->

          <div class="container-B-Form">
            <div class="justify-Content-Right font-Main-Elements">
              First Name:
            </div>
            <div class="justify-Content-Left textbox-padding">
              <input
                @input="handleTextboxInput($event)"
                id="firstNameTxtBx"
                v-model="firstName"
                type="text"
              />
            </div>
            <div class="justify-Content-Right font-Main-Elements">
              Last Name:
            </div>
            <div class="justify-Content-Left textbox-padding">
              <input
                @input="handleTextboxInput($event)"
                id="lastNameTxtBx"
                v-model="lastName"
                type="text"
              />
            </div>
            <div class="justify-Content-Right font-Main-Elements">Role:</div>
            <div class="justify-Content-Left textbox-padding">
              <input
                @input="handleTextboxInput($event)"
                id="roleTxtBx"
                v-model="role"
                type="text"
              />
            </div>
            <div></div>
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- FORM END --------------------------- -->
          <!-- ---------------------------------------------------------------- -->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn closeButton" data-bs-dismiss="modal">
            Cancel
          </button>
          <button
            type="button"
            id="submitBtn"
            disabled="true"
            @click="handleUserEditSubmit"
            class="btn yesButton"
            data-bs-dismiss="modal"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- --------------------------------------------------------- -->
  <!-- ---------------- modal EDIT - End ----------------------- -->
  <!-- --------------------------------------------------------- -->

  <!-- --------------------------------------------------------- -->
  <!-- ---------------- modal INFO - Start --------------------- -->
  <!-- --------------------------------------------------------- -->

  <div
    class="modal fade"
    id="infoModal"
    tabindex="-1"
    aria-labelledby="infoModalLabelID"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="infoModalLabelID">User Details</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dishandleTextboxInputmiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- FORM ------------------------------- -->
          <!-- ---------------------------------------------------------------- -->

          <div class="container-B-Form">
            <div class="justify-Content-Right font-Main-Elements">
              First Name:
            </div>
            <div class="justify-Content-Left font-record textbox-padding">
              {{ firstName }}
            </div>
            <div class="justify-Content-Right font-Main-Elements">
              Last Name:
            </div>
            <div class="justify-Content-Left font-record textbox-padding">
              {{ lastName }}
            </div>
            <div class="justify-Content-Right font-Main-Elements">Role:</div>
            <div class="justify-Content-Left font-record textbox-padding">
              {{ role }}
            </div>
            <div class="justify-Content-Right font-Main-Elements">Details:</div>
            <div class="justify-Content-Left font-record textbox-padding">
              This contains additional details.
            </div>
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- FORM END --------------------------- -->
          <!-- ---------------------------------------------------------------- -->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn closeButton" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- --------------------------------------------------------- -->
  <!-- ---------------- modal INFO - End ----------------------- -->
  <!-- --------------------------------------------------------- -->
</template>

<script>
import CmpGrid from "../../../components/dataSupport/CmpGrid.vue";
import axios from "axios";

export default {
  name: "HomeView",
  data() {
    return {
      gridTime: { grid: null, time: null },

      // --------- Edit/Delete -------------

      deleteRecord: null,
      editRecord: null,
      firstName: "",
      lastName: "",
      role: "",
      roleID: null,
      userID: null,
    };
  },
  created() {
    // console.log("----> HostCmpGrid.vue:created()");
    this.getAllUsers();
  },

  methods: {
    getAllUsers() {
      console.log("HostCmpGrid.vue:getAllUsers()");
      axios
        .get("https://localhost:7100/api/User/SelAllUsers")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          console.log("---->> last then: HostCmpGrid getAllUsers()");
          // console.log("data = ", data);
          // console.log("data.length = ", data.length);
        });
    },
    // -----------------------------------------------------------------
    // ----------------------- Edit Delete -----------------------------
    // -----------------------------------------------------------------

    // ---------- EDIT

    editRow(args) {
      this.$data.editRecord = args.itemArg;

      this.$data.firstName = this.$data.editRecord["firstName"];
      this.$data.lastName = this.$data.editRecord["lastName"];
      this.$data.role = this.$data.editRecord["role"];
      this.$data.roleID = this.$data.editRecord["role_ID"];
      this.$data.userID = this.$data.editRecord["user_ID"];
    },

    handleTextboxInput() {
      // console.log("userHasChanged = ", this.$data.userHasChanged);
      let btn = document.querySelector("#submitBtn");
      btn.disabled = false;
      // btn.classList = 'btn btn-primary submit-Enabled';
    },

    handleUserEditSubmit() {
      // console.log("**** handleUserEditSubmit ****");

      // console.log("firstName = ", this.$data.firstName);
      // console.log("lastName = ", this.$data.lastName);
      // console.log("role = ", this.$data.role);

      let btn = document.querySelector("#submitBtn");
      btn.disabled = true;

      this.updateEditedUser();
    },

    updateEditedUser() {
      axios
        .post(
          "https://localhost:7100/api/User/UpdateUser/" +
            this.$data.userID +
            "/" +
            this.$data.firstName +
            "/" +
            this.$data.lastName +
            "/" +
            this.$data.role +
            "/" +
            this.$data.roleID
        )
        .then((response) => response.data)
        .then((data) => {
          // console.log("**** CmpGridHost: updateEditedUser ****");
          // console.log("updateUser(): data: ", data);

          //Upon submit, no user is selected.
          this.$data.firstName = "";
          this.$data.lastName = "";
          this.$data.role = "";
          this.$data.roleID = "";
          this.$data.userID = null;

          //The UpdateUser function returns the updated dataset. This is needed
          //due to the asyncronous nature of the code.
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
        });
    },

    //---------- DELETE

    deleteRow(args) {
      this.$data.deleteRecord = args.itemArg;

      this.$data.firstName = this.$data.deleteRecord["firstName"];
      this.$data.lastName = this.$data.deleteRecord["lastName"];
      this.$data.role = this.$data.deleteRecord["role"];
      this.$data.roleID = this.$data.deleteRecord["role_ID"];
      this.$data.userID = this.$data.deleteRecord["user_ID"];
    },
    handleSubmitDelete() {
      console.log("--------> handleSubmitDelete()");
      this.deleteUser();
    },

    deleteUser() {
      axios
        .post("https://localhost:7100/api/User/DeleteUser/" + this.$data.userID)
        .then((response) => response.data)
        .then((data) => {
          //Upon submit, no user is selected.
          this.$data.firstName = "";
          this.$data.lastName = "";
          this.$data.role = "";
          this.$data.roleID = "";
          this.$data.userID = null;

          //The DeleteUser function returns the updated dataset. This is needed
          //due to the asyncronous nature of the code.
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
        });
    },
  },
  components: { CmpGrid },
};
</script>

<style scoped>
.container-main-div {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin: 0px;
  margin-top: 20px;
  /* background-color: rgb(193, 236, 190); */
}

.gridWidth {
  width: 80%;
  margin-bottom: 50px;
}

/* --------------- actions ----------- */

.actionsHeader {
  color: blue;
  font-family: "Handlee";
  font-size: 16px;
  padding: 0px;
  margin: 0px;
}

/* -------------- slot actions ---------------- */

.forIconEdit {
  margin-left: 5px;
  color: rgb(6, 106, 11);
  cursor: pointer;
  font-size: 20px;
}

.forIconInfo {
  margin-left: 5px;
  color: rgb(99, 3, 88);
  cursor: pointer;
  font-size: 20px;
}

.forIconDelete {
  margin-left: 20px;
  color: rgb(102, 16, 4);
  cursor: pointer;
  font-size: 20px;
}
/* -------------------------------------------------- */
/* ------------------- modal ------------------------ */
/* -------------------------------------------------- */

.container-B-Form {
  margin: 5px;
  display: grid;
  grid-template-rows: 40px, 40px, 40px;
  grid-template-columns: 35% 65%;
  align-items: center;
  justify-content: center;

  /* background-color: lightyellow; */
}

.modalElementMargin {
  margin-top: 5px;
}

/* ----------------- Font - Main Elements --------- */

.textbox-padding {
  padding: 5px;
}

.font-Main-Elements {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: rgb(2, 2, 175);
}

.font-record {
  color: rgb(77, 0, 0);
  font-weight: bold;
}
.closeButton {
  background-color: rgb(65, 3, 3);
  color: white;
}

.closeButton:hover {
  background-color: rgb(92, 4, 4);
  color: white;
}

.yesButton {
  background-color: rgb(12, 40, 0);
  color: white;
}

.yesButton:hover {
  background-color: rgb(19, 64, 0);
  color: white;
}

.justify-Content-Right {
  display: flex;
  justify-content: right;
  padding-right: 10px;
}
.justify-Content-Left {
  display: flex;
  justify-content: left;
  align-items: center;
}

/* --------------------------------------- */
/* -------------- End Modal -------------- */
/* --------------------------------------- */
</style>
